/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInfo
 */
export interface ProjectInfo {
    /**
     * 
     * @type {string}
     * @memberof ProjectInfo
     */
    title: string;
    /**
     * 
     * @type {PostalAddress}
     * @memberof ProjectInfo
     */
    location?: PostalAddress;
    /**
     * 
     * @type {Date}
     * @memberof ProjectInfo
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectInfo
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfo
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfo
     */
    companyId: string;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ProjectInfo
     */
    activityArea?: ActivityArea;
}

/**
 * Check if a given object implements the ProjectInfo interface.
 */
export function instanceOfProjectInfo(value: object): value is ProjectInfo {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function ProjectInfoFromJSON(json: any): ProjectInfo {
    return ProjectInfoFromJSONTyped(json, false);
}

export function ProjectInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'location': json['location'] == null ? undefined : PostalAddressFromJSON(json['location']),
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'company': json['company'],
        'companyId': json['companyId'],
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
    };
}

export function ProjectInfoToJSON(value?: ProjectInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'location': PostalAddressToJSON(value['location']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'company': value['company'],
        'companyId': value['companyId'],
        'activityArea': ActivityAreaToJSON(value['activityArea']),
    };
}

